/**
 * Apre una scheda placeholder (chiamare in modo sincrono dal click utente
 * per evitare il blocco popup del browser).
 */
export function openPrintPlaceholderWindow(title = "Preparazione stampa…") {
  const printWindow = window.open("about:blank", "_blank");
  if (!printWindow) return null;
  try {
    printWindow.opener = null;
  } catch {
    /* ignore */
  }
  const safeTitle = String(title).replace(/[<>&]/g, "");
  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${safeTitle}</title>
  <style>
    body { font-family: system-ui, sans-serif; padding: 2rem; color: #334155; }
  </style>
</head>
<body>
  <p>Preparazione documento per la stampa...</p>
</body>
</html>`);
  printWindow.document.close();
  return printWindow;
}

/**
 * Carica un Blob PDF in una finestra e avvia la stampa nativa del browser.
 * @returns {{ ok: true } | { ok: false, reason: "popup_blocked" }}
 */
export function printPdfBlob(blob, { title = "Stampa PDF", printWindow: existingWindow } = {}) {
  const pdfBlob =
    blob instanceof Blob && blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const blobUrl = window.URL.createObjectURL(pdfBlob);

  let printWindow = existingWindow && !existingWindow.closed ? existingWindow : null;
  if (!printWindow) {
    printWindow = window.open("about:blank", "_blank");
  }
  if (!printWindow) {
    window.URL.revokeObjectURL(blobUrl);
    return { ok: false, reason: "popup_blocked" };
  }

  try {
    printWindow.opener = null;
  } catch {
    /* ignore */
  }

  try {
    printWindow.document.title = title;
  } catch {
    /* ignore */
  }
  printWindow.location.href = blobUrl;
  setTimeout(() => {
    try {
      printWindow.focus();
      printWindow.print();
    } catch {
      /* Il viewer PDF gestisce la stampa manualmente se necessario */
    }
  }, 900);
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 120000);
  return { ok: true };
}
